import React from "react";
import { useLocation } from "react-router-dom";
import style from "css/questions.module.css";
import { useMediaQuery } from "react-responsive";

function Questions() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  //navigate
  const { pathname } = useLocation();
  const path = process.env.NODE_ENV === "production" ? "/riv" : "/";
  return (isMobile || isTablet) &&
    (pathname.split(path)[1] === "" || pathname.split(path)[1] === "/") ? (
    <div
      className={
        pathname.split(path)[1] === "" || pathname.split(path)[1] === "/"
          ? style.questions_wrap_landing
          : style.questions_wrap
      }
    >
      <div className={style.questions_link_box_wrap}>
        <div
          className={style.questions_link_box_item}
          style={{
            backgroundImage:
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/questions/consultation.webp')",
          }}
        >
          <div className={style.questions_link_box}>
            <span className={style.question_link_title}>상담 문의</span>
            <p className={style.question_link_text}>
              상담 문의를 통해 필요한 정보와 맞춤형 제안을 받아보세요. 저희
              전문가 팀이 신속하고 정확한 답변을 드리겠습니다.
            </p>
          </div>
          {/* <div className={style.qustions_link_btn_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` + "img/common/right.webp"
              }
              alt="right"
            />
          </div> */}
          <div className={style.questions_contact_box}>
            <span className={style.question_link_title}>
              <a href="tel:070-7798-1311">070-7798-1311</a>
            </span>
          </div>
        </div>
        <div
          className={style.questions_link_box_item}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/questions/partnership.webp')",
          }}
        >
          <div className={style.questions_link_box}>
            <span className={style.question_link_title}>제휴/제안 문의</span>
            <p className={style.question_link_text}>
              {
                "제휴 및 제안 문의를 통해 비즈니스 협업과 공동의 성장을 위한 아이디어를 나눠보세요. 파트너십을 통해 더 큰 시너지를 만들어가겠습니다."
              }
            </p>
          </div>
          {/* <div className={style.qustions_link_btn_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` + "img/common/right.webp"
              }
              alt="right"
            />
          </div> */}
          <div className={style.questions_contact_box}>
            <span className={style.question_link_title}>
              support@riv-tech.co.kr
            </span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={
        pathname.split(path)[1] === "" || pathname.split(path)[1] === "/"
          ? style.questions_wrap_landing
          : style.questions_wrap
      }
    >
      <span className={style.questions_title}>
        리브테크놀로지의 솔루션에 대해{"\n"} 더 궁금한 점이 있으신가요?
      </span>
      <div className={style.questions_link_box_wrap}>
        <div
          className={style.questions_link_box_item}
          style={{
            backgroundImage:
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/questions/consultation.webp')",
          }}
        >
          <div className={style.questions_link_box}>
            <span className={style.question_link_title}>상담 문의</span>
            <p className={style.question_link_text}>
              상담 문의를 통해 필요한 정보와 맞춤형 제안을 받아보세요. 저희
              전문가 팀이 신속하고 정확한 답변을 드리겠습니다.
            </p>
          </div>
          {/* <div className={style.qustions_link_btn_wrap}>
            <button className={style.questions_link_btn}>
              <span className={style.questions_link_btn_text}>
                상담 문의하기
              </span>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/common/right.webp"
                }
                alt="right"
              ></img>
            </button>
          </div> */}
          <div className={style.questions_contact_box}>
            <span className={style.question_link_title}>
              <a href="tel:070-7798-1311">070-7798-1311</a>
            </span>
          </div>
        </div>
        <div
          className={style.questions_link_box_item}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/questions/partnership.webp')",
          }}
        >
          <div className={style.questions_link_box}>
            <span className={style.question_link_title}>제휴/제안 문의</span>
            <p className={style.question_link_text}>
              {
                "제휴 및 제안 문의를 통해 비즈니스 협업과 공동의 성장을 위한 아이디어를 나눠보세요. 파트너십을 통해 더 큰 시너지를 만들어가겠습니다."
              }
            </p>
          </div>
          {/* <div className={style.qustions_link_btn_wrap}>
            <button className={style.questions_link_btn}>
              <span className={style.questions_link_btn_text}>
                제휴/제안 문의하기
              </span>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/common/right.webp"
                }
                alt="right"
              ></img>
            </button>
          </div> */}
          <div className={style.questions_contact_box}>
            <span className={style.question_link_title}>
              support@riv-tech.co.kr
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Questions;
